export default async function invokeFunction(functionName, params = {}) {
  // GET rather than POST so the browser and the CDN in front of the functions
  // can both reuse the response
  const query = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null)
  );
  const response = await fetch(`/api/${functionName}?${query.toString()}`);

  if (!response.ok) {
    let message = `API error (${response.status})`;
    try {
      const err = await response.json();
      message = err.error || message;
    } catch (e) {
      console.error(e);
    }
    throw new Error(message);
  }

  return {
    data: await response.json()
  };
}
